exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner{margin:auto;opacity:.5;border:0px solid rgba(0,0,0,0);-webkit-box-sizing:content-box;box-sizing:content-box}.spinner .ring{width:100%;height:100%;border-radius:50%;border:4px solid #fff;border-color:#fff rgba(0,0,0,0) #fff #fff;-webkit-animation:spin .7s linear infinite;animation:spin .7s linear infinite}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/components/spinner/style.scss
// module id = 1251
// module chunks = 58